import React, { useEffect } from 'react'
import { isDesktop, isMobile, isTablet } from 'react-device-detect'
import { consoleLog } from 'utils/simpleLogger'

export enum IframeTypeEnum {
  ACH,
  CREDIT_CARD,
}

interface IframeProps {
  source: string
  title: string
  type: IframeTypeEnum
  proceed?: any
  onCancel?: () => void
}

const Iframe = ({ source, title, proceed, onCancel, type }: IframeProps) => {
  useEffect(() => {
    const handleReceiveMessage = (event: MessageEvent) => {
      // Ensure you validate the origin if necessary
      const origin =
        process.env.REACT_APP_ENV === 'prod'
          ? 'https://api.norcapsecurities.com'
          : 'https://api-sandboxdash.norcapsecurities.com'

      try {
        if (event.origin === origin && typeof event.data === 'string') {
          consoleLog('Iframe event origin', event)
          const data = JSON.parse(event.data)
          consoleLog('Iframe event data', data)
          if (data.statusCode === 101) {
            proceed()
          } else if (data.statusCode === '101') {
            proceed(data.plaidAccountDetails[0].account_name)
          } else if (data.errorCode === '404') {
            onCancel && onCancel()
          }
        } else {
          consoleLog('Iframe else event origin', event)
          const data = JSON.parse(event.data)
          if (data.errorCode === '404') {
            onCancel && onCancel()
          }
        }
      } catch (error) {
        console.log(error)
      }
    }

    window.addEventListener('message', handleReceiveMessage)

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('message', handleReceiveMessage)
    }
  }, []) // eslint-disable-line

  const getIframeAttributes = () => {
    const isSmallScreen = (isMobile || isTablet) && !isDesktop
    switch (type) {
      case IframeTypeEnum.ACH:
        return {
          width: isSmallScreen ? '300px' : '600px',
          height: isSmallScreen ? '600px' : '700px',
        }
      case IframeTypeEnum.CREDIT_CARD:
        return {
          width: isSmallScreen ? '375px' : '600px',
          height: isSmallScreen ? '400px' : '400px',
        }
    }
  }

  const { width, height } = getIframeAttributes()

  return (
    <div>
      <iframe src={source} width={width} height={height} title={title}></iframe>
    </div>
  )
}

export default Iframe
